export async function tryFetch(apiFn, cacheKey, transform) {
	try {
		const raw = await apiFn();
		const data = transform ? transform(raw) : raw;
		try { localStorage.setItem(cacheKey, JSON.stringify(data)); } catch(e) { /* ignore */ }
		return data;
	} catch(e) {
		console.error(`Tried to fetch ${cacheKey}`, e);
		try {
			const cached = localStorage.getItem(cacheKey);
			if(cached) return JSON.parse(cached);
		} catch(e2) {
			console.error(`Parsing JSON for ${cacheKey} from localStorage`, e2);
		}
		return null;
	}
}
